import React from "react";

// Full-bleed photographic page banner with gold/sea overlay
export default function HeroBanner({ image, eyebrow, title, description, icon, children, testid }) {
  return (
    <div className="hero-banner relative mb-6 overflow-hidden rounded-2xl gold-ring" data-testid={testid}>
      <img src={image} alt="" className="absolute inset-0 h-full w-full object-cover" loading="eager" />
      <div className="absolute inset-0 bg-gradient-to-r from-[#030A16]/90 via-[#030A16]/60 to-[#030A16]/20" />
      <div className="absolute inset-0 bg-gradient-to-t from-[#030A16]/70 to-transparent" />
      <div className="relative flex flex-wrap items-end justify-between gap-4 p-6 sm:p-8">
        <div className="flex items-center gap-4">
          {icon && <img src={icon} alt="" className="h-14 w-14 rounded-full border-2 border-[hsl(var(--gold))]/70 object-cover shadow-lg sm:h-16 sm:w-16" />}
          <div>
            {eyebrow && <p className="label-eyebrow text-[hsl(var(--gold))]">{eyebrow}</p>}
            <h1 className="mt-1 font-display text-3xl font-700 tracking-tight text-white drop-shadow sm:text-4xl lg:text-5xl">{title}</h1>
            {description && <p className="mt-2 max-w-2xl text-sm text-white/80">{description}</p>}
          </div>
        </div>
        {children && <div className="flex items-center gap-2 [&_button]:border-white/30 [&_button]:bg-white/10 [&_button]:text-white [&_button]:backdrop-blur hover:[&_button]:bg-white/20">{children}</div>}
      </div>
    </div>
  );
}
